var map = {
	"./about_logo": 317,
	"./about_logo.png": 317,
	"./admin/4pt-logo": 318,
	"./admin/4pt-logo.png": 318,
	"./admin/auth-bg": 319,
	"./admin/auth-bg.jpg": 319,
	"./admin/calendar": 320,
	"./admin/calendar.svg": 320,
	"./admin/eye": 321,
	"./admin/eye.svg": 321,
	"./admin/icons/article": 322,
	"./admin/icons/article.svg": 322,
	"./admin/icons/banner": 323,
	"./admin/icons/banner.svg": 323,
	"./admin/icons/cart": 324,
	"./admin/icons/cart.svg": 324,
	"./admin/icons/contact": 325,
	"./admin/icons/contact.svg": 325,
	"./admin/icons/default": 326,
	"./admin/icons/default.svg": 326,
	"./admin/icons/faq": 327,
	"./admin/icons/faq.svg": 327,
	"./admin/icons/home": 328,
	"./admin/icons/home.svg": 328,
	"./admin/icons/member": 329,
	"./admin/icons/member.svg": 329,
	"./admin/icons/setting": 330,
	"./admin/icons/setting.svg": 330,
	"./admin/pen": 331,
	"./admin/pen.svg": 331,
	"./admin/pen_w": 332,
	"./admin/pen_w.svg": 332,
	"./admin/photo": 333,
	"./admin/photo.svg": 333,
	"./admin/return": 334,
	"./admin/return.svg": 334,
	"./admin/search": 335,
	"./admin/search.svg": 335,
	"./admin/trash": 336,
	"./admin/trash.svg": 336,
	"./arrow": 337,
	"./arrow.svg": 337,
	"./daodi-logo": 287,
	"./daodi-logo-original": 338,
	"./daodi-logo-original.jpg": 338,
	"./daodi-logo.jpg": 397,
	"./daodi-logo.png": 287,
	"./daodi-logo.svg": 398,
	"./facebook": 339,
	"./facebook.svg": 339,
	"./footer_logo": 340,
	"./footer_logo.png": 340,
	"./instant": 341,
	"./instant.svg": 341,
	"./partner/pic_1": 342,
	"./partner/pic_1.png": 342,
	"./partner/pic_1@2x": 343,
	"./partner/pic_1@2x.png": 343,
	"./partner/pic_2": 344,
	"./partner/pic_2.png": 344,
	"./partner/pic_2@2x": 345,
	"./partner/pic_2@2x.png": 345,
	"./partner/pic_3": 346,
	"./partner/pic_3.png": 346,
	"./partner/pic_3@2x": 347,
	"./partner/pic_3@2x.png": 347,
	"./partner/pic_4": 348,
	"./partner/pic_4.png": 348,
	"./partner/pic_4@2x": 349,
	"./partner/pic_4@2x.png": 349,
	"./partner/pic_5": 350,
	"./partner/pic_5.png": 350,
	"./partner/pic_5@2x": 351,
	"./partner/pic_5@2x.png": 351,
	"./partner/pic_6": 352,
	"./partner/pic_6.png": 352,
	"./partner/pic_6@2x": 353,
	"./partner/pic_6@2x.png": 353,
	"./partner/pic_7": 354,
	"./partner/pic_7.png": 354,
	"./partner/pic_7@2x": 355,
	"./partner/pic_7@2x.png": 355,
	"./prize_icon": 356,
	"./prize_icon.svg": 356,
	"./sponsors/sponsor-01": 357,
	"./sponsors/sponsor-01.png": 357,
	"./sponsors/sponsor-01@2x": 358,
	"./sponsors/sponsor-01@2x.png": 358,
	"./sponsors/sponsor-02": 359,
	"./sponsors/sponsor-02.png": 359,
	"./sponsors/sponsor-02@2x": 360,
	"./sponsors/sponsor-02@2x.png": 360,
	"./sponsors/sponsor-03": 361,
	"./sponsors/sponsor-03.png": 361,
	"./sponsors/sponsor-03@2x": 362,
	"./sponsors/sponsor-03@2x.png": 362,
	"./sponsors/sponsor-04": 363,
	"./sponsors/sponsor-04.png": 363,
	"./sponsors/sponsor-04@2x": 364,
	"./sponsors/sponsor-04@2x.png": 364,
	"./sponsors/sponsor-05": 365,
	"./sponsors/sponsor-05.png": 365,
	"./sponsors/sponsor-05@2x": 366,
	"./sponsors/sponsor-05@2x.png": 366,
	"./world_map": 367,
	"./world_map.svg": 367,
	"./youtube": 368,
	"./youtube.svg": 368
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 396;